import styled from "styled-components";

export const Container = styled.div<{
	scale: number;
	left: number;
	top: number;
}>`
	//width: 331px;
	position: fixed;
	top: ${(props) => props.top}px;
	left: ${(props) => props.left}px;
	transform: scale(${(props) => props?.scale});
	transform-origin: top left;
`;

export const ArrowContainer = styled.div<{ scale: number }>`
	margin-left: calc(40% * ${(props) => props.scale});
	display: flex;
	justify-content: center;
`;

export const SlideNumberContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 4px;
	margin-right: 10px;
`;

export const ContainerPointBalance = styled.div<{ top: number; left: number }>`
	position: fixed;
	top: ${(props) => props.top}px;
	left: ${(props) => props.left}px;
`;
